<script>
import Vue from 'vue'
// import { Component, Prop, Vue } from 'vue-property-decorator';

import Component from 'vue-class-component'
import { containerSkewOpen, containerSkewClose, containerSkewFadeout } from '@/ui/UIUtil'

Component.registerHooks([
    "beforeRouteEnter",
    "beforeRouteLeave",
    "beforeRouteUpdate"
]);


const fadeMSec  = 50;
const mainColor = "#FF0000";

const pageOpen =  async ( beforeClose=null) =>{
    console.info('page opening');
    return new Promise( function( resolve ) {
      const menuContainer = jQuery( '#opener_showCase');
      if( menuContainer.length > 0 ){
        containerSkewOpen( menuContainer, null, function(){
          console.info( 'fading out ')
          containerSkewFadeout( 
            jQuery( '#opener_showCase'), 
            fadeMSec, 
            beforeClose, 
            function(){ 
              console.info('after fading out');
              resolve();
            }.bind(this));
        });
      } else {
        resolve( true );
      }
    } );
  }




@Component
export default class BaseView extends Vue {
	
  panelColor = "0000FF";

  
  async beforeRouteEnter(to, from, next){
    // called before the route that renders this component is confirmed.
    // does NOT have access to `this` component instance,
    // because it has not been created yet when this guard is called!
    console.log('beforeRouteEnterb' );
    var res = await pageOpen();
    console.log('after fading out #2 before next()');
    next();
    
  }

  created() {
    // `this` points to the vm instance
    console.info('created!')
  }


  getPanelColor(){
    return mainColor;
  }

  async beforeRouteUpdate(to, from, next) {

    // called when the route that renders this component has changed.
    // This component being reused (by using an explicit `key`) in the new route or not doesn't change anything.
    // For example, for a route with dynamic params `/foo/:id`, when we
    // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
    // will be reused (unless you provided a `key` to `<router-view>`), and this hook will be called when that happens.
    // has access to `this` component instance.
    console.log('beforeRouteUpdate ');
    next();
  }

  // beforeRouteLeave (to, from, next) {
  //   // called when the route that renders this component is about to
  //   // be navigated away from.
  //   console.log('beforeRouteLeave ');
  //   next();
  // }

}
</script>


<style>
.pageContainer{
  position: absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
}
</style>
